import { MooringOfferService, MooringService } from 'services/mooring';
import { autoinject, bindable } from 'aurelia-framework';
import { AsyncErrorHandler } from 'lib/ui';
import { MooringReviewDto, CommentForEntity } from 'models/mooring';
import { PubSub } from 'lib/event/PubSub';
import { ConfirmDialog } from 'components/dialogs/confirm/confirm-dialog';
import { ToastService } from 'services';

@autoinject()
export class Overview {
  constructor(
    private offerService: MooringOfferService,
    private mooringService: MooringService,
    private pubsub: PubSub,
    private confirm: ConfirmDialog,
    private toaster: ToastService
  ) {}
}
